import { Reveal, Eyebrow } from "@/components/Reveal";
import { STORE } from "@/lib/catalog";

const SECTIONS = [
  {
    title: "1. Product Information",
    body: `We make every effort to keep product names, pack sizes, descriptions and prices shown on this website accurate. However, packaging, brand availability and MRP may change without notice. The price applicable at the time of billing in-store or on delivery will be final.`,
  },
  {
    title: "2. Availability",
    body: `Listing a product on this website does not guarantee it is in stock at the moment of your order. Adding items to an enquiry list or submitting the contact form is a request, not a confirmed order. We always confirm availability and the final amount with you by phone or WhatsApp before dispatch.`,
  },
  {
    title: "3. Pricing & Payment",
    body: `All prices are in Indian Rupees (₹) and inclusive of applicable taxes unless stated otherwise. No online payment is collected through this website — payment is made on delivery or at the counter. Any "approx." totals shown in the enquiry list are estimates for your convenience only.`,
  },
  {
    title: "4. Delivery",
    body: `Free same-day doorstep delivery is offered within our immediate neighbourhood, subject to order size, weather, and staff availability. Delivery timelines shared on call or WhatsApp are best-effort estimates, not guarantees.`,
  },
  {
    title: "5. Images & Content",
    body: `Some photographs on this website are illustrative stock images and may not represent the exact brand or pack available in-store. All website content is the property of Shivam Kirana Store and may not be reproduced without permission.`,
  },
  {
    title: "6. External Links",
    body: `This website may contain links to third-party services (such as WhatsApp). We are not responsible for the content, privacy practices, or availability of external services.`,
  },
  {
    title: "7. Limitation of Liability",
    body: `Shivam Kirana Store shall not be liable for any indirect or consequential loss arising from the use of this website. Nothing in this disclaimer affects your statutory rights as a consumer under applicable Indian law.`,
  },
  {
    title: "8. Contact",
    body: `Questions about this disclaimer? Contact ${STORE.owner} at ${STORE.email} or call ${STORE.phoneIntl}. Store address: ${STORE.address}.`,
  },
];

export default function Disclaimer() {
  return (
    <main className="bg-bone min-h-screen" data-testid="disclaimer-page">
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-24">
        <Reveal>
          <Eyebrow>Legal</Eyebrow>
          <h1 className="mt-4 font-serif font-bold text-4xl sm:text-5xl tracking-tight text-ink">Disclaimer</h1>
          <p className="mt-3 text-sm text-ink-muted">Last updated: July 2026 · Shivam Kirana Store, Kanpur</p>
          <p className="mt-6 text-ink-soft leading-relaxed">
            Straight talk, as always — the fine print about prices, stock and delivery,
            written so you can actually read it.
          </p>
        </Reveal>
        <div className="mt-10 space-y-8">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={Math.min(i * 0.05, 0.3)}>
              <section className="rounded-2xl border border-line bg-white p-6 sm:p-8">
                <h2 className="font-serif font-semibold text-xl text-forest">{s.title}</h2>
                <p className="mt-3 text-sm sm:text-base text-ink-soft leading-relaxed">{s.body}</p>
              </section>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
